import React from 'react'
import { noDataText } from '../constants'

const NoDataSection = ({ text = noDataText }) => (
    <div className='no-data-section'>{text}</div>
)

export default NoDataSection
